import React from 'react';
import SpecificComponent from '../../commons/SpecificComponent'
import AppBar from '../../commons/AppBar'
import { Button, Grid } from '@material-ui/core';
import avatar from '../../Pics/avatar.jpg'
import LocalStorage from '../../providers/LocalStorage';
import Organigrama from '../../commons/Organigrama';
import Ws from '../../providers/Ws';
import Ponteaza from '../../commons/dialogs/Ponteaza';
import Utils from '../../providers/Utils';
import DrepturiAcces from '../drepturiacces/DrepturiAcces';
import PropTest from './PropTest';
import totalWorks from '../../Pics/Logo-TotalWorks.png'

export default class Home extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            objUser: {},
            isOpenPotaj: false,
            status: null,
            nrOraInceput: new Utils().getTimeNow(),
            nrOraSfarsit: new Utils().getTimeNow(),
            timer: `00:00:00`
        }
    }



    drepturiAccess = new DrepturiAcces()

    goToPage = (page) => {

        this.props.history.push(`/${page}`)
    }


    componentDidMount() {
        this.getDetaliiUser()


    }

    getDetaliiUser = async () => {
        let ws = new Ws()

        let ls = new LocalStorage()

        let user = await ws.customSelect(`select a.*, u.email, u.telefon from angajati a 
                                        left outer join useri u on (a.id_user = u.id) where u.id = @p1 `, {
            p1: ls.GetUserData().InfoUser.IdUser
        })



        let dA = this.drepturiAccess.getDrepturiAplicatie()

        // let dP = this.drepturiAccess.getAccesProiecte()

        // let updateULog = ws.update('pm_logator.[dbo].useri', { inactiv: 0 }, { id_user_bazadate_proprie: 1 })

        // console.log('dA :>> ', dA);

        // console.log('dP :>> ', dP);
        // console.log('user :', user);
        if (user.Succes) {
            this.setState({ objUser: user.Content[0] }, () => {
                // console.log('this.staet.objUser :', this.state.objUser);
            })
        }
    }

    // selectFile = (id) => {
     
    //     let pi = document.getElementById(id);

    //     pi.click()
    // }

    // uploadPoza = async (id, idAngajat) => {
    //     let ws = new Ws();
    //     //  console.log('Picture changed func');
    //     let saveFile = document.getElementById(id).files[0];
    //     let reader = new FileReader();
    //     reader.readAsDataURL(saveFile);

    //     reader.onload = async () => {
    //         let fileContent = reader.result;
    //         // console.log(fileContent);
    //         // console.log('saveFile :', saveFile);


    //         let uploadImage = await ws.uploadimage('Upload/PozaAngajat', saveFile, idAngajat);

    //         // console.log('uploadImage :', uploadImage);
    //         if (uploadImage.Succes) {
    //             this.getDetaliiUser()
    //         }
    //         //console.log('uploadimage :', uploadImage);
    //         // console.log('uploadFileApiCall :', uploadFileApiCall);

    //     }
    // }

    // goToUser = () => {
    //     let lS = new LocalStorage()

    //     let user = lS.GetUserData()

    //     //  console.log('user :', user);

    //     if (user.InfoUser.IsAdmin) {
    //         this.props.history.push('/users')
    //     } else {
    //         this.props.history.push(`/infouser/${user.InfoUser.IdUser}`)
    //     }
    // }

    // handleChange = (e) => {
    //     this.setState({ [e.target.name]: e.target.value })
    // }

    // addPontaj = () => {

    //     let u = new Utils()



    //     let elapsedTime = u.getElapsedTime(this.state.nrOraInceput, new Date())


    //     if (this.state.status === null) {
    //         this.setState({
    //             status: 'Started',
    //             seconds: new Date().getSeconds(),
    //             nrOraInceput: this.state.nrOraInceput
    //         }, () => {
    //             this.openPontaj()
    //         })

    //     } else {
    //         this.setState({
    //             status: 'Sfarsit',
    //             nrOraSfarsit: this.state.nrOraSfarsit,

    //         }, () => {
    //             this.openPontaj()
    //         })
    //     }

    // }


    downloadAplicatie = () =>{ 
        console.log('aplicatie :>> ');

       window.open(`https://proiecte.totalsoftware.ro/storage/kituri/pm_installer.zip`)
    }


    downloadMonitorizare = () =>{ 
        console.log('monitorizare :>> ');

        window.open('https://proiecte.totalsoftware.ro/storage/kituri/pm_monitoring.zip')
    }



    render() {
        return (
            <div>
                <AppBar history={this.props.history} title={this.dictionary.appBar.drawer.home} />

                <Grid style={{ maxWidth: 1000, margin: 'auto' }} container>

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <h1 style={{ margin: '80px 0 40px 0' }} className='pm-title-big'>{this.dictionary.home.controlPanel}</h1>
                        {/* <h5 style={{ textAlign: 'left', fontWeight: 400 }}>{this.state.listAllDocs.length} Proiecte {this.state.proiecteDocs} Documente</h5> */}
                    </Grid>

                    <Grid style={{ textAlign: 'left' }} item xs={10} sm={10} md={10} lg={10} xl={10}>
                        <img src={totalWorks} style={{ maxWidth: 120, maxHeight: 120 }} alt="" />
                    </Grid>


                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <h4 style={{ textAlign: 'left' }} >{this.dictionary.home.mesajPanouControl}</h4>
                        {/* <h5 style={{ textAlign: 'left', fontWeight: 400 }}>{this.state.listAllDocs.length} Proiecte {this.state.proiecteDocs} Documente</h5> */}
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <h4 style={{ textAlign: 'left' }} >{this.dictionary.home.downloadAplicatie}</h4>
                        {/* <h5 style={{ textAlign: 'left', fontWeight: 400 }}>{this.state.listAllDocs.length} Proiecte {this.state.proiecteDocs} Documente</h5> */}
                    </Grid>

                    <Grid style={{textAlign:'left'}} item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Button
                              style={{ marginRight: 20 }}

                            className={'add-button-blue'} onClick={() => { this.downloadAplicatie() }}  >

                            <i style={{
                                fontSize: 20,
                                marginRight: 10
                            }} className='material-icons'>upload_file</i>  {this.dictionary.home.downloadApp}
                        </Button>

                        <Button
                        

                            className={'add-button-blue'} onClick={() => { this.downloadMonitorizare() }}  >

                            <i style={{
                                fontSize: 20,
                                marginRight: 10
                            }} className='material-icons'>upload_file</i>  {this.dictionary.home.downloadMonitorizare}
                        </Button>
                        {/* <h5 style={{ textAlign: 'left', fontWeight: 400 }}>{this.state.listAllDocs.length} Proiecte {this.state.proiecteDocs} Documente</h5> */}
                    </Grid>
                </Grid>

                {/* <Ponteaza
                    open={this.state.isOpenPotaj}
                    dialogClose={()=>{this.setState({isOpenPotaj:false})}}
                    title={'Pontaj'}
                    timer={this.state.timer}
                    status={this.state.status}
                    nrOraInceput={this.state.nrOraInceput}
                    nrOraSfarsit={this.state.nrOraSfarsit}
                    handleChange={this.handleChange}
                    addPontaj={this.addPontaj} />

                <Grid style={{ maxWidth: 1080, width: '95%', margin: '120px auto' }} container>
                    <Grid item style={{ textAlign: 'left', marginBottom: 50, maxHeight: 400 }} xs={12} sm={12} md={12} lg={12} xl={12}>

                        <div
                        onClick={this.goToUser}
                        id='pm-user-avatar' style={{
                            width: 100,
                            height: 100,
                            backgroundImage: `url(${this.state.objUser.poza ? (new Ws().adresaMedia + '/Angajati/' + this.state.objUser.poza) : avatar})`,
                            backgroundRepeat: 'no-reapeat',
                            backgroundPosition: 'center',
                            backgroundSize: 'cover',
                            display: 'inline-block'
                        }}>
                        <input type='file' id={`fileavatar`}
                                                              style={{display:'none'}}
                                                              accept='image/*'
                                                              onChange={()=>{this.uploadPoza(`fileavatar`, this.state.objUser.id)}} />    

                        </div>


                        <div className='pm-user-info'>

                            <h3 style={{ marginBottom: 0, textAlign: 'left', marginTop: 0 }} className='pm-title'>{this.state.objUser.nume}</h3>
                            <h5 style={{ marginTop: 5, textAlign: 'left' }} className='pm-title'>Manager</h5>
                            <h4 style={{ marginBottom: 0, textAlign: 'left', marginTop: 0 }} className='pm-title'>Email: {this.state.objUser.email}</h4>

                        </div>



                        {/* <Organigrama /> */}

                {/* </Grid>

                    <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>

                        <div onClick={() => { this.goToPage('projects') }} style={{ backgroundColor: '#d07070b5' }} className='pm-home-cards' >

                            <i className='material-icons pm-home-buttons-icons'>assessment</i>
                            <span className='pm-home-card-text'>{this.dictionary.home.managementProiecte}</span>
                        </div>


                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>

                        <div style={{ backgroundColor: '#5c5ce2b8' }} className='pm-home-cards'>
                            <i className='material-icons pm-home-buttons-icons'>event_note</i>
                            <span className='pm-home-card-text'>{this.dictionary.home.chestionare}</span>
                        </div>


                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>

                        <div onClick={() => { this.goToPage('financiarcontabil') }} style={{ backgroundColor: '#abab2fa8' }} className='pm-home-cards'>
                            <i className='material-icons pm-home-buttons-icons'>money</i>
                            <span className='pm-home-card-text'>{this.dictionary.home.financiar}</span>
                        </div>


                    </Grid>

                    <Grid onClick={()=>{new LocalStorage().GetUserData().InfoUser.IsAdmin !== 1 ? this.goToPage(`pontaj/${this.state.objUser.id}`) : this.goToPage(`pontaje`)}}  item xs={12} sm={6} md={4} lg={4} xl={4}>

                        <div style={{ backgroundColor: '#9a1eb7a3' }} className='pm-home-cards'>
                            <i className='material-icons pm-home-buttons-icons'>timer</i>
                            <span className='pm-home-card-text'>{this.dictionary.home.pontaj}</span>
                        </div>


                    </Grid>

                    <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>

                        <div onClick={() => { this.goToPage('evaluareactivitati') }} style={{ backgroundColor: '#1bce2ac4' }} className='pm-home-cards'>
                            <i className='material-icons pm-home-buttons-icons'>assignment_ind</i>
                            <span className='pm-home-card-text'>{this.dictionary.home.evalActivitatiiAngajati}</span>
                        </div>


                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>

                        <div style={{ backgroundColor: '#00c2ffcc' }} className='pm-home-cards'>
                            <i className='material-icons pm-home-buttons-icons'>people_outline</i>
                            <span className='pm-home-card-text'>{this.dictionary.home.evalDeColegi}</span>
                        </div>


                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>

                        <div style={{ backgroundColor: '#ff8400d4' }} className='pm-home-cards'>
                            <i className='material-icons pm-home-buttons-icons'>people</i>
                            <span className='pm-home-card-text'>{this.dictionary.home.evalClienti}</span>
                        </div>


                    </Grid>

                    <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>

                        <div onClick={() => { this.goToPage('organigrama') }} style={{ backgroundColor: 'rgba(239, 16, 96, 0.83)' }} className='pm-home-cards'>
                            <i className='material-icons pm-home-buttons-icons'>device_hub</i>
                            <span className='pm-home-card-text'>{this.dictionary.home.organigrama}</span>
                        </div>


                    </Grid> */}

                {/* <Grid item  xs={12} sm={6} md={6} lg={6} xl={6}>
                               <div onClick={()=>{this.goToPage('projects')}} className='pm-home-buttons' style={{lineHeight:'inherit', backgroundColor:'#9a30d6', borderBottomColor:'#986bc1'}}>
                               <span style={{display:'block', marginTop:44}}>Management de proiecte</span>
                               </div>
                                   
                                
                      </Grid>

                      <Grid item  xs={12} sm={6} md={6} lg={6} xl={6}>
                               <div onClick={()=>{this.goToPage('chestionare')}} className='pm-home-buttons'>
                               <span >Chestionare</span>
                               </div>
                                   
                                
                      </Grid>

                      <Grid item  xs={12} sm={6} md={6} lg={6} xl={6}>
                               <div onClick={()=>{this.goToPage('financiarcontabil')}} className='pm-home-buttons' style={{backgroundColor:'#3dd818', borderBottomColor:'#288449'}}>
                               <span >Financiar</span>
                               </div>
                                   
                                
                      </Grid>

                      <Grid item  xs={12} sm={6} md={6} lg={6} xl={6}>
                               <div className='pm-home-buttons' style={{backgroundColor:'#6f8abfe0', borderBottomColor:'#2c6e88'}}>
                               <span >Pontaj</span>
                               </div>
                                   
                                
                      </Grid>

                      <Grid item  xs={12} sm={6} md={6} lg={6} xl={6}>
                               <div className='pm-home-buttons' style={{lineHeight:'inherit', backgroundColor:'#ff81f3', borderBottomColor:'#da7474'}}>
                               <span style={{display:'block', marginTop:37}}>Evaluarea activitatii angajati</span>
                               </div>
                                   
                                
                      </Grid>
                      <Grid item  xs={12} sm={6} md={6} lg={6} xl={6}>
                               <div className='pm-home-buttons' style={{lineHeight:'inherit' , backgroundColor:'#e60844', borderBottomColor:'#bf2355'}}>
                               <span style={{display:'block', marginTop:42}}>Evaluarea de catre colegi</span>
                               </div>
                                   
                                
                      </Grid>
                      <Grid item  xs={12} sm={6} md={6} lg={6} xl={6}>
                               <div style={{lineHeight:'inherit', backgroundColor:'#2e40ca', borderBottomColor:'#7f88ec'}} className='pm-home-buttons'>
                               <span style={{display:'block', marginTop:37}}>Evaluarea din partea clientilor</span>
                               </div>
                                   
                                
                      </Grid> */}
                {/* </Grid> */}




            </div>
        );
    }
}
